/**
 visible :弹框是否可见
 handleOk：ok事件
 handleCancel：关闭弹框事件
 dom：要传入显示的内容
*/

import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'antd'
import './index.scss'
const classObj = {
  large: 'common-modal',
  middle: 'anan-modal-middle',
  quotation: 'anan-modal-quotation'
}
function ModalDom (props) {
  const { height, icon, title, iconfont, className, id, maskClosable, width } = props
  return (
    <Modal
      visible={props.visible}
      onOk={props.handleOk}
      onCancel={props.handleCancel}
      footer={null}
      maskClosable={maskClosable}
      closable={false}
      zIndex={999}
      wrapClassName={classObj[height] + ' ' + className}
      width={width}
    >
      <div className='modal-dom-wrapper'>
        {
          <div className=' pl20 pb10 cursor-pointer title-modal' id={id}>
            {/* 解决modal里面没有内容 关闭按钮position:fixed会不显示问题 */}
            <div style={{ height: '.1rem' }} />
            {/* 关闭按钮 */}
            {
              icon === 'close' &&
                <>
                  <i className={`iconfont f20 ${iconfont}`} onClick={props.handleCancel} />
                  <div className='title pt10'>{title}</div>
                </>
            }
            {/* 返回按钮 */}
            {
              icon === 'back' &&
                <i className='iconfont iconReturns_icon f20' onClick={props.onBack} />
            }
          </div>
        }
        {props.dom || props.children}
      </div>
    </Modal>
  )
}
ModalDom.propTypes = {
  visible: PropTypes.bool,
  handleOk: PropTypes.func,
  handleCancel: PropTypes.func,
  onBack: PropTypes.func,
  dom: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.node
  ]),
  height: PropTypes.string,
  icon: PropTypes.string,
  iconfont: PropTypes.string,
  title: PropTypes.string,
  width: PropTypes.number
}

ModalDom.defaultProps = {
  visible: false,
  handleOk: () => {},
  handleCancel: () => {},
  onBack: () => {},
  dom: '',
  height: 'large',
  icon: 'close',
  iconfont: 'iconguanbi-heisex',
  title: '',
  width: 824
}
export default ModalDom
